// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Platform from '../../../components/common/Platform';
import { CardTypes } from '../../../types/Model';
import { S } from '../styles';
import homeSelector from '../../../redux/selectors/homeSelector';
import { actionCreatorsList } from '../../../redux/rootActionCreator';
import { CompletionStatusType } from '../../../types/Model';
import { FormattedMessage } from 'react-intl';

const { sortHomeHistoryAction } = actionCreatorsList;
export interface ProductHistoryRow {
  type: CardTypes;
  name: string;
  platformId: number;
  levelId: number;
  completionStatus: CompletionStatusType;
  completionTime: Date | null;
  id: number;
}
interface HistoryTableProps extends Omit<ComponentPropsWithRef<'div'>, 'id'> {
  list: ProductHistoryRow[];
}

const HistoryTable = ({ list }: HistoryTableProps): JSX.Element => {
  const currentSortingKey = useSelector(homeSelector.makeHomeSortingKey());
  const isAscending = useSelector(homeSelector.makeHomeIsAscending());
  const dispatch = useDispatch();
  const Headers = {
    type: 'B021',
    name: 'B022',
    platformId: 'B023',
    levelId: 'B024',
    completionStatus: 'B025',
    completionTime: 'B026',
    id: 'B038',
  }

  enum typeTag {
    onlineCourse = 'B005',
    // lab = 'B006',
    workshop = 'B004',
    // challenge = 'B036',
    // exam = 'B040',
  }

  const handleSorting = (nextSortingKey: keyof ProductHistoryRow) => {
    dispatch(sortHomeHistoryAction(nextSortingKey))
  }

  return (
    <S.HistoryTableWrapper>
      {
        (Object.keys(Headers) as Array<keyof ProductHistoryRow>).map((key: keyof ProductHistoryRow, index) => (
          <S.TableHeading
            key={index}
            onClick={() => handleSorting(key)}
            isCenter={[0, 2, 3, 4, 5, 6].indexOf(index) !== -1}
          >
            <S.TableHeadingText><FormattedMessage id={Headers[key]} values={{ br: (<br />) }} />{currentSortingKey === key && <S.TableSortIcon isAscending={isAscending} />}</S.TableHeadingText>
          </S.TableHeading>
        ))
      }
      {list.map((value: ProductHistoryRow) => {
        switch (value.type) {
          case CardTypes.WORKSHOP:
            return (
              <React.Fragment key={`workshop_${value.id}`}>
                <S.TableCell isCenter><FormattedMessage id={typeTag[value.type]} /></S.TableCell>
                <S.TableCell>{value.name}</S.TableCell>
                <S.TableCell isCenter><Platform id={value.platformId} /></S.TableCell>
                <S.TableCell><S.LevelMeter levelId={value.levelId} showName={true} /></S.TableCell>
                <S.TableCell isCenter><S.CompletionStatusTag type={value.completionStatus} /></S.TableCell>
                <S.TableCell isCenter>{value.completionTime ? moment(value.completionTime).format('YYYY/MM/DD') : '--'}</S.TableCell>
                <S.TableCell><S.TableCellLink to={`/workshops/${value.id}`}><FormattedMessage id={'B039'} /></S.TableCellLink></S.TableCell>
              </React.Fragment>
            )
          case CardTypes.COURSE:
            return (
              <React.Fragment key={`course_${value.id}`}>
                <S.TableCell isCenter><FormattedMessage id={typeTag[value.type]} /></S.TableCell>
                <S.TableCell>{value.name}</S.TableCell>
                <S.TableCell isCenter><Platform id={value.platformId} /></S.TableCell>
                <S.TableCell><S.LevelMeter levelId={value.levelId} showName={true} /></S.TableCell>
                <S.TableCell isCenter><S.CompletionStatusTag type={value.completionStatus} /></S.TableCell>
                <S.TableCell isCenter>{value.completionTime ? moment(value.completionTime).format('YYYY/MM/DD') : '--'}</S.TableCell>
                <S.TableCell><S.TableCellLink to={`/onlineCourses/${value.id}`}><FormattedMessage id={'B039'} /></S.TableCellLink></S.TableCell>
              </React.Fragment>
            )
          // 原歷史紀錄 > 課程紀錄 只顯示 course/workshop
          // case CardTypes.LAB:
          //   return (
          //     <>
          //       <S.TableCell isCenter><FormattedMessage id={typeTag[value.type]} /></S.TableCell>
          //       <S.TableCell>{value.name}</S.TableCell>
          //       <S.TableCell isCenter><Platform id={value.platformId} /></S.TableCell>
          //       <S.TableCell><S.LevelMeter levelId={value.levelId} showName={true} /></S.TableCell>
          //       <S.TableCell isCenter><S.CompletionStatusTag type={value.completionStatus} /></S.TableCell>
          //       <S.TableCell isCenter>{value.completionTime ? moment(value.completionTime).format('YYYY/MM/DD') : '--'}</S.TableCell>
          //       <S.TableCell><S.TableCellLink to={value.type == CardTypes.WORKSHOP ? `/workshops/${value.id}` : `/labs/${value.id}`}><FormattedMessage id={'B039'} /></S.TableCellLink></S.TableCell>
          //     </>
          //   )
          // case CardTypes.CHALLENGE:
          //   return (
          //     <>
          //       <S.TableCell isCenter><FormattedMessage id={typeTag[value.type]} /></S.TableCell>
          //       <S.TableCell>{value.name}</S.TableCell>
          //       <S.TableCell isCenter><Platform id={value.platformId} /></S.TableCell>
          //       <S.TableCell><S.LevelMeter levelId={value.levelId} showName={true} /></S.TableCell>
          //       <S.TableCell isCenter><S.CompletionStatusTag type={value.completionStatus} /></S.TableCell>
          //       <S.TableCell isCenter>{value.completionTime ? moment(value.completionTime).format('YYYY/MM/DD') : '--'}</S.TableCell>
          //       <S.TableCell><S.TableCellLink to={`/challenges/${value.id}`}><FormattedMessage id={'B039'} /></S.TableCellLink></S.TableCell>
          //     </>
          //   )
          // case CardTypes.EXAM:
          //   return (
          //     <>
          //       <S.TableCell isCenter><FormattedMessage id={typeTag[value.type]} /></S.TableCell>
          //       <S.TableCell>{value.name}</S.TableCell>
          //       <S.TableCell isCenter><Platform id={value.platformId} /></S.TableCell>
          //       <S.TableCell><S.LevelMeter levelId={value.levelId} showName={true} /></S.TableCell>
          //       <S.TableCell isCenter><S.CompletionStatusTag type={value.completionStatus} /></S.TableCell>
          //       <S.TableCell isCenter>{value.completionTime ? moment(value.completionTime).format('YYYY/MM/DD') : '--'}</S.TableCell>
          //       <S.TableCell><S.TableCellLink to={`/exams/${value.id}`}><FormattedMessage id={'B039'} /></S.TableCellLink></S.TableCell>
          //     </>
          //   )
          default:
            return null;
        }
      })}
    </S.HistoryTableWrapper>
  );
};

export { HistoryTable as default };
